export default class AlQrCodeContentSelectorController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.translate = this.injector.get('$translate');
        this.acl = this.injector.get('Acl');
        this.timeout = this.injector.get('$timeout');
        this.activeQrCodeTypes = [];

        this.content = '';

        this.disabled = false;
        this.currentContent = '';
        this.currentUpdateIndex = 0;
        this.onContentChange = () => {
        };

        this.currentSelectedCodeType = 'rsvp_code';

        this._prepareAvailableQrCodeTypes();
    }

    $onInit() {
        this.content = _.clone(this.currentContent) || '';

        let newQrCodeType = 'custom';
        this.currentSelectedCodeType = 'custom';

        _.each(_.filter(this._getQrCodeTypes(), (qrCodeType) => qrCodeType.accessor()), (qrCodeType) => {
            if (qrCodeType.key === 'custom') {
                return;
            }

            if (this.content === qrCodeType.content()) {
                newQrCodeType = qrCodeType.key;
            }
        })

        this.currentSelectedCodeType = newQrCodeType;

        this._initWatchers();
    }

    handleQrCodeTypeChange() {
        const qrCodeType = _.first(_.filter(this._getQrCodeTypes(), (type) => (this.currentSelectedCodeType === type.key)));

        if (qrCodeType && _.isFunction(qrCodeType.content)) {
            this.content = qrCodeType.content();
        }
    }

    _prepareAvailableQrCodeTypes() {
        this.activeQrCodeTypes = _.map(_.filter(this._getQrCodeTypes(), (qrCodeType) => qrCodeType.accessor()), (qrCodeType) => {
            return {
                key: qrCodeType.key,
                label: this.translate.instant(`wallets.templates.editor.cards.qr_code.labels.${qrCodeType.key}`),
                note: this.translate.instant(`wallets.templates.editor.cards.qr_code.notes.${qrCodeType.key}`)
            }
        });

    }

    _getQrCodeTypes() {
        return [
            {
                key: 'rsvp_code',
                content: () => '{{rsvp.code}}',
                accessor: () => true
            },
            {
                key: 'contact_code',
                content: () => '{{contact.code}}',
                accessor: () => this.acl.hasModule('addressbook')
            },
            {
                key: 'custom',
                content: () => {
                    return this.content;
                },
                accessor: () => true
            }
        ];
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.currentSelectedCodeType,
            () => this.handleQrCodeTypeChange()
        );

        this.scope.$watch(
            () => this.content,
            () => {
                if (!_.isEqual(this.content, this.currentContent)) {
                    const curUpdateIndex = ++this.currentUpdateIndex;

                    this.timeout(() => {
                        if (curUpdateIndex === this.currentUpdateIndex) {
                            this.onContentChange({content: _.clone(this.content)});
                        }
                    }, 400);
                }
            }
        );
    }
}

AlQrCodeContentSelectorController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-qr-code-content-selector/controller.js